import React from "react";

export default function PageTitle({ title }) {
    return (
        <div className="px-4 py-5 sm:px-6">
            <h1 className="font-MulishBlack text-xl capitalize">{title}</h1>
        </div>
    );
}
